import { createAsyncThunk } from '@reduxjs/toolkit'
import { PerformerController } from 'controller/performer/controller'

import { IPerformerData } from 'meta/pages/v4/performer'

type Returned = IPerformerData

type Props = {
  code: string
}

export const getData = createAsyncThunk<Returned, Props>('pages/performer/data', async (props) => {
  const { code } = props

  return PerformerController.getData({ code })
})
